import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import { BatteryFull } from "lucide-react";

export default function StorageSystem({ batteries, onBatteryClick }) {
  return (
    <Box
      sx={{
        bgcolor: "white",
        borderRadius: 3,
        boxShadow: 3,
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      {/* Header */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, mb: 2, bgcolor: "#F9FAFB", borderRadius: "8px", boxShadow: "0 1px 3px rgba(0,0,0,0.08)", flexShrink: 0, }}>
        <Box
         sx={{ p: 1, bgcolor: "#EFF6FF", borderRadius: 1 }}
        >
          <BatteryFull size={18} color="#059669" />
        </Box>

        {/* Title Text */}
        <Typography
          variant="h6"
          fontWeight={600}
          sx={{
            fontSize: "1rem",       
            lineHeight: 1.2,       
            whiteSpace: "nowrap",
          }}
        >
          Battery Energy Storage System
        </Typography>
      </Box>

      {/* Batteries */}
      <Box sx={{ overflowY: "auto", flexGrow: 1, pr: 1 }}>
        {batteries.map((b) => (
          <Box
            key={b.id}
            onClick={() => onBatteryClick(b)}
            sx={{
              p: 1.5,
              mb: 1.5,
              borderRadius: 2,
              border: "1px solid",
              borderColor: "grey.100",
              "&:hover": {
                boxShadow: 2,
                bgcolor: "#fafafa",
                cursor: "pointer",
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 0.5,
              }}
            >
              <Typography variant="body2" fontWeight={600}>
                {b.name}
              </Typography>
              <Typography variant="body2" fontWeight={700}>
                {b.charge}%
              </Typography>
            </Box>

            <LinearProgress
              variant="determinate"
              value={b.charge}
              sx={{
                height: 8,
                borderRadius: 1,
                mb: 1,
                backgroundColor: "grey.200",
                "& .MuiLinearProgress-bar": {
                  borderRadius: 1,
                  background:
                    b.charge >= 60
                      ? "linear-gradient(90deg,#34d399,#059669)"
                      : b.charge >= 30
                      ? "linear-gradient(90deg,#facc15,#eab308)"
                      : "linear-gradient(90deg,#f87171,#dc2626)",
                },
              }}
            />

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "0.75rem",
                color: "text.secondary",
              }}
            >
              <span>Charge</span>
              <span>{b.chargeRate || 0} kW</span>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: "0.75rem",
                color: "text.secondary",
              }}
            >
              <span>Discharge</span>
              <span>{b.dischargeRate || 0} kW</span>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
